import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import { PopUpView } from '../../../../MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { toastifyFn, isSupportedTenantCode } from 'common/utilities/utils';
import PersonalInfoCard from '../../Presentation/AccountSettings/PersonalInfoCard';
import CommunicationPreferencesCard from '../../Presentation/AccountSettings/CommunicationPreferencesCard';
import DeleteAccountInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { ACCOUNT_SETTINGS, USER_FORM_FIELDS, COMMUNICATION_PREFERENCES_CONSTANTS } from '../../Constants/Constants';
import OtpScreen from './OtpScreen';
import { updateCustomerInfo, getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import {
  monthList,
  updateCommunicationPreferencesAnalytics,
  checkUpdatedInfo,
} from 'organisms/AccountPage/AU/accountPageUtils';
import { deleteAccountAnalytics } from 'organisms/AccountPage/accountPageUtils';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import {
  actions as brazeActions,
  selectBrazeSubscriptionResponse,
} from '@kfc-global/react-shared/redux/Slices/BrazeSubscriptionSliceV2';
import { ROUTE_URL, BRAZE_COOKIES } from 'common/constants/SharedConstants';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import update from 'lodash/update';
import get from 'lodash/get';

const DeleteAccountConfirmModal = ({ handleClose, deleteAccountCallback, CartError }) => {
  const { DELETE_ACCOUNT_MESSAGE, CANCEL, DELETE_ACCOUNT_BTN } = ACCOUNT_SETTINGS;

  const DELETE_ACCOUNT_CONSTANTS = {
    CONFIRM_DELETE_MSG: {
      MSGTXT1: translateWithI18Next(DELETE_ACCOUNT_MESSAGE),
    },
  };
  return (
    <React.Fragment>
      <DeleteAccountInsideModel
        handleClose={handleClose}
        classNames='delete-account-modal'
        CartAlertForm={
          <AlertForm
            splitTitle={DELETE_ACCOUNT_CONSTANTS.CONFIRM_DELETE_MSG}
            imageSrc={CartError}
            altText={'delete-account'}
            cancelButtonText={translateWithI18Next(CANCEL)}
            confirmButtonText={translateWithI18Next(DELETE_ACCOUNT_BTN)}
            confirmHandler={deleteAccountCallback}
            cancelHandler={handleClose}
          />
        }
      />
    </React.Fragment>
  );
};

const subscriptionFn = subscriptions => {
  const brazeSubscription = { ...subscriptions };
  const newUserSubscription = AuthManager.getInstance().emailSubscription;
  brazeSubscription['marketing-emails'] = !newUserSubscription
    ? newUserSubscription
    : subscriptions['marketing-emails'];
  return brazeSubscription;
};

const updateSubscriptionStatus = (brazeSubscriptionStatus, subscriptionField, pref) => {
  const result = JSON.parse(JSON.stringify(brazeSubscriptionStatus));
  const data = `${subscriptionField}.subscribed`;
  const selectedPref = get(pref, subscriptionField, {});
  return update(result, data, () => !selectedPref.subscribed);
};

export const handleOneTrustBanner = () => {
  window?.OneTrust?.ToggleInfoDisplay();
};

const AccountSettingsContainer = ({ updateMenu, isMobile }) => {
  const {
    ACCOUNT_SETTINGS_TEXT,
    DELETE_ACCOUNT_TEXT,
    SUBSCRIBTION_MSG_TEXT,
    UNSUBSCRIBTION_MSG_TEXT,
    EXCEEDED_VERIFICATION_ATTEMPTS,
    YOUR_INFO_SAVED,
    EDIT_WITH_OLD_PHONE,
    FROM_OTP_SCREEN,
  } = ACCOUNT_SETTINGS;
  const { MARKETING_EMAIL, MARKETING_SMS } = COMMUNICATION_PREFERENCES_CONSTANTS;
  const { SingleArrowback } = IMAGE_PATH;
  const dispatch = useDispatch();
  const history = useHistory();
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [openEditInfoFlag, setOpenEditInfoFlag] = useState(false);
  const profileReducer = useSelector(data => data.profileReducer || null);
  const tenantReducer = useSelector(data => data.tenantReducer || null);
  const authReducer = useSelector(data => data.authReducer || null);
  const brazeSubscriptions = useSelector(data => data.brazeSubscriptionReducerV2 || null);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [otpSendTo, setOtpSendTo] = useState();
  const [updatedCustomerData, setUpdatedCustomerData] = useState();
  const [isOtpMatch, setIsOtpMatch] = useState(true);
  const [invalidOtpCount, setInvaliOtpCount] = useState(0);
  const { subscriptions = {} } = useAppSelector(selectBrazeSubscriptionResponse);
  const [brazeSubscriptionStatus, setBrazeSubscriptionStatus] = useState(subscriptions);
  const { basic: { email, firstName, lastName, phone } = {} } = profileReducer ?? {};
  const basicInfoObj = { email, firstName, lastName, phone };
  const brazeSubscription = subscriptionFn(subscriptions);
  const [brazeCookiesAccperted, setBrazeCookiesAccepted] = useState(true);
  const BrazeNotificationSubscriptionTypes = window?.appboy?.User?.NotificationSubscriptionTypes;

  useEffect(() => {
    window?.OnetrustActiveGroups &&
      setBrazeCookiesAccepted(JSON.stringify(window?.OnetrustActiveGroups).includes(BRAZE_COOKIES));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window?.OnetrustActiveGroups]);

  useEffect(() => {
    const externalId = tenantReducer?.brazeMparticle ? window?.mParticle?.Store?.mpid : profileReducer?.customerId;
    if (email) {
      dispatch(brazeActions.fetch({ customerId: externalId }));
    }
  }, [dispatch, email, profileReducer?.customerId, tenantReducer?.brazeMparticle]);

  useEffect(() => {
    if (history?.location?.hash?.includes(ROUTE_URL.ACCOUNT_SETTINGS)) {
      const hash = window?.location?.hash?.split('?')[1];
      const urlSearchParams = new URLSearchParams(hash);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (hash && USER_FORM_FIELDS.includes(params?.field)) {
        setOpenEditInfoFlag(true);
      }
    }
  }, [history, profileReducer]);

  const deleteAccountCallback = () => {
    deleteAccountAnalytics(profileReducer?.customerId);
    AuthManager.getInstance().deleteAccount();
    setConfirmDialog(false);
  };
  const closeOtpModalHandler = () => {
    setOpenOtpModal(false);
  };
  const handleClose = () => {
    setConfirmDialog(false);
  };

  const updateCustomerData = updatedData => {
    const {
      firstName,
      middleName = '',
      lastName,
      email: emailData,
      phone,
      postalCode = null,
      day,
      month,
      year,
      allowOtpPopup,
    } = updatedData;
    if (!allowOtpPopup) {
      setOtpSendTo(phone);
    }
    setOpenEditInfoFlag(true);
    const userPhoneNumber = profileReducer?.basic?.phone;
    let selectedMonth = monthList.indexOf(month) + 1;

    const profileInfo = {
      birthYear: year ? String(year) : null,
      birthDay: day ? String((day < 10 && `0${day}`) || day) : null,
      birthMonth: selectedMonth ? String((selectedMonth < 10 && `0${selectedMonth}`) || selectedMonth) : null,
      postalCode: postalCode || null,
    };
    let setProfileInfo = { ...updatedData, profileInfo };
    setUpdatedCustomerData(setProfileInfo);

    if (phone.replace(/ /g, '') === userPhoneNumber || allowOtpPopup === true) {
      callUpdateCustomerInfoAPI(
        firstName,
        middleName,
        lastName,
        emailData,
        phone,
        profileInfo,
        false,
        '',
        'fromEditWithOldPhone',
      );
      setOpenEditInfoFlag(false);
      if (!allowOtpPopup) {
        setInvaliOtpCount(0);
      }
    } else {
      callUpdateCustomerInfoAPI(
        firstName,
        middleName,
        lastName,
        emailData,
        phone,
        profileInfo,
        true,
        '',
        'fromResendOtpScreen',
        true,
      );
      hideError();
      setOpenOtpModal(true);
      setInvaliOtpCount(0);
    }
  };
  const callUpdateCustomerInfoAPI = (
    firstName,
    middleName,
    lastName,
    email,
    phone,
    profileInfo,
    otpValidationRequired,
    otp,
    screen,
    successCallBackNotNeeded,
  ) => {
    const updatedData = { email, firstName, lastName, phone };
    const updatedFlag = checkUpdatedInfo(updatedData, basicInfoObj, profileInfo);
    const params = {
      screen,
      otp,
      fName: firstName,
      lName: lastName,
      email,
      phoneNo: phone,
      profileInfo,
      successCallBackNotNeeded,
      updatedFlag,
    };
    dispatch(
      updateCustomerInfo({
        sucessCallback: () => callSignInApi(params),
        errorCallBack: screen !== 'fromResendOtpScreen' && errorCallBackOTP,
        tenantId: tenantReducer?.tenantId,
        customerId: profileReducer?.basic?.id,
        body: {
          firstName,
          middleName: middleName,
          lastName,
          emailId: email.trim().length > 0 ? email : '',
          phoneNumber: phone.replace(/ /g, ''),
          attributes: profileInfo,
          otpValidationRequired,
          otp,
          isSopac: isSupportedTenantCode(),
        },
      }),
    );
  };

  const errorCallBackOTP = () => {
    setIsOtpMatch(false);
    setInvaliOtpCount(invalidOtpCount + 1);
    if (invalidOtpCount >= 2) {
      setOpenOtpModal(false);
    }
  };

  const callSignInApi = params => {
    const {
      screen,
      otp,
      fName,
      lName,
      email: emailData,
      phoneNo,
      profileInfo,
      successCallBackNotNeeded,
      updatedFlag,
    } = params;
    if (successCallBackNotNeeded) {
      return;
    }
    const reqPayload = {
      fName,
      lName,
      emailId: emailData,
      phoneNumber: phoneNo.replace(/ /g, ''),
      attributes: profileInfo,
      isUpdated: updatedFlag,
    };
    dispatch(getCustomerInfo(reqPayload));
    if (screen === EDIT_WITH_OLD_PHONE || otp) {
      toastifyFn(translateWithI18Next(YOUR_INFO_SAVED));
    }
    if (screen === FROM_OTP_SCREEN) {
      setOpenOtpModal(false);
      setOpenEditInfoFlag(false);
    }
  };
  const callValidateOtpAPI = otpValue => {
    const { firstName, middleName, lastName, email: emailData, phone, profileInfo } = updatedCustomerData;
    callUpdateCustomerInfoAPI(
      firstName,
      middleName,
      lastName,
      emailData,
      phone,
      profileInfo,
      true,
      otpValue,
      'fromOtpScreen',
    );
  };

  const callResendOtpAPI = () => {
    const { firstName, middleName, lastName, email: emailData, phone, profileInfo } = updatedCustomerData;
    callUpdateCustomerInfoAPI(
      firstName,
      middleName,
      lastName,
      emailData,
      phone,
      profileInfo,
      true,
      '',
      'fromResendOtpScreen',
      true,
    );
    hideError();
    setInvaliOtpCount(0);
  };

  const editAccountInfoModal = flag => {
    setIsOtpMatch(true);
    if (flag === 'fromEditClick') {
      setOpenEditInfoFlag(true);
    } else {
      setOpenEditInfoFlag(false);
      setInvaliOtpCount(0);
    }
  };
  const hideError = () => {
    setIsOtpMatch(true);
  };

  useEffect(() => {
    setBrazeSubscriptionStatus(subscriptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brazeSubscriptions?.loading]);

  const setEmailNotification = subscriptionStatus => {
    return window?.appboy?.getUser()?.setEmailNotificationSubscriptionType(subscriptionStatus) ?? false;
  };

  const handleSubscriptionStatus = (pref, subscriptionField) => {
    const result = updateSubscriptionStatus(brazeSubscriptionStatus, subscriptionField, pref);
    setBrazeSubscriptionStatus(result);
    const selectedPrefStatus = get(result, subscriptionField, {});
    const subscriptionStatus = pref?.email?.subscribed
      ? BrazeNotificationSubscriptionTypes.UNSUBSCRIBED
      : BrazeNotificationSubscriptionTypes.SUBSCRIBED;
    if (tenantReducer?.brazeSMSMarketingOption) {
      const subscriptionGroupId =
        subscriptionField === MARKETING_EMAIL ? tenantReducer.brazeEmailGroupId : tenantReducer.brazeSMSGroupId;
      if (selectedPrefStatus.subscribed) {
        window?.appboy?.getUser()?.addToSubscriptionGroup(subscriptionGroupId);
      } else {
        window?.appboy?.getUser()?.removeFromSubscriptionGroup(subscriptionGroupId);
      }
    } else {
      setEmailNotification(subscriptionStatus);
    }

    const selectedPrefData = [
      { subscribe: result?.email?.subscribed, key: MARKETING_EMAIL },
      { subscribe: result?.sms?.subscribed, key: MARKETING_SMS },
    ];
    const selectedPreference = selectedPrefData.reduce((obj, item) => {
      item.subscribe && obj.push(item.key);
      return obj;
    }, []);
    updateCommunicationPreferencesAnalytics(selectedPreference);
    const subUnsubToastMsgKey = selectedPrefStatus?.subscribed ? SUBSCRIBTION_MSG_TEXT : UNSUBSCRIBTION_MSG_TEXT;
    toastifyFn(translateWithI18Next(subUnsubToastMsgKey));
  };

  return (
    <div className='account-settings-container'>
      <div className='account-settings-header-mobile'>
        <img
          className='backArrow-account-setting'
          onClick={() => updateMenu('')}
          src={SingleArrowback}
          alt='back btn'
        />
        <span className='account-setting-text-header'>{translateWithI18Next(ACCOUNT_SETTINGS_TEXT)}</span>
      </div>
      <p className='account-setting-text-heading'>{translateWithI18Next(ACCOUNT_SETTINGS_TEXT)}</p>
      {openEditInfoFlag && invalidOtpCount === 3 && (
        <div class='verification-faild-container'>
          <div>
            {' '}
            <img src={IMAGE_PATH.Error} alt='Error visible' />{' '}
          </div>
          <div>
            <span> {translateWithI18Next(EXCEEDED_VERIFICATION_ATTEMPTS)}</span>
          </div>
        </div>
      )}
      <PersonalInfoCard
        profileReducer={profileReducer}
        authReducer={authReducer}
        tenantReducer={tenantReducer}
        updateCustomerData={updateCustomerData}
        editAccountInfoModal={editAccountInfoModal}
        isMobile={isMobile}
        openEditInfoFlag={openEditInfoFlag}
        updatedCustomerData={updatedCustomerData}
      />
      {tenantReducer?.componentOptions?.accountSettings?.communicationPreferenceComponent && (
        <CommunicationPreferencesCard
          brazeSubscriptionStatus={brazeSubscriptionStatus}
          handleSubscriptionStatus={handleSubscriptionStatus}
          loading={brazeSubscriptions?.loading}
          tenantReducer={tenantReducer}
          brazeCookiesAccperted={brazeCookiesAccperted}
          handleOneTrustBanner={handleOneTrustBanner}
        />
      )}
      <ButtonComp
        data-testid='delete-button-testid'
        className='delete-account-button delete-account-button-au'
        onClickHandler={() => {
          setConfirmDialog(true);
          PopUpView({ popupTitle: translateWithI18Next(DELETE_ACCOUNT_TEXT) });
        }}
      >
        {translateWithI18Next(DELETE_ACCOUNT_TEXT)}
      </ButtonComp>
      {confirmDialog && (
        <DeleteAccountConfirmModal
          handleClose={handleClose}
          deleteAccountCallback={deleteAccountCallback}
          CartError={IMAGE_PATH.CartError}
        />
      )}

      {openOtpModal && (
        <OtpScreen
          closeOtpModalHandler={closeOtpModalHandler}
          otpSendTo={otpSendTo}
          profileReducer={profileReducer}
          tenantReducer={tenantReducer}
          callValidateOtpAPI={callValidateOtpAPI}
          callResendOtpAPI={callResendOtpAPI}
          isOtpMatch={isOtpMatch}
          hideError={hideError}
          invalidOtpCount={invalidOtpCount}
        />
      )}
    </div>
  );
};

export default AccountSettingsContainer;
